import { render, staticRenderFns } from "./MetacoSignIn.vue?vue&type=template&id=5385fe4a&"
import script from "./MetacoSignIn.vue?vue&type=script&lang=js&"
export * from "./MetacoSignIn.vue?vue&type=script&lang=js&"
import style0 from "./MetacoSignIn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports